import React from 'react';
import { Link } from 'react-router-dom';
import { cn } from '../../lib/utils';

/* StatCard — the dashboard's status-card pattern.
   Uppercase mono label at top, big value (often an LED readout) in the
   middle, optional bottom link separated by a hairline rule. Cards in a
   grid layout will all share the same height because the link sits on
   `mt-auto`. */

interface StatCardProps {
  label: string;
  children: React.ReactNode;
  linkTo?: string;
  linkText?: string;
  /** Optional external link instead of an internal route. */
  linkHref?: string;
  className?: string;
}

export default function StatCard({
  label,
  children,
  linkTo,
  linkHref,
  linkText,
  className,
}: StatCardProps) {
  const linkClass =
    'mt-4 pt-3 border-t border-border font-mono text-xs tracking-[0.14em] lowercase text-primary hover:opacity-80 transition-opacity inline-flex items-center gap-1.5';

  return (
    <div
      className={cn(
        'bg-card border border-border rounded-sm p-6 flex flex-col h-full',
        className
      )}
    >
      <h3 className="font-mono text-xs tracking-[0.18em] uppercase text-muted-foreground mb-4">
        {label}
      </h3>
      <div className="flex-1 flex items-end">{children}</div>
      {linkText && linkTo && (
        <Link to={linkTo} className={linkClass}>
          {linkText} →
        </Link>
      )}
      {linkText && linkHref && !linkTo && (
        <a href={linkHref} className={linkClass}>
          {linkText} →
        </a>
      )}
    </div>
  );
}
